import React from 'react';
import kebabCase from 'lodash/kebabCase';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';

export interface IAvailableIconOptions {
	calianIconSelectValues?:
		| 'Activity'
		| 'Alert'
		| 'Arrow Right'
		| 'Article'
		| 'Barbell'
		| 'Bell'
		| 'Brand Linkedin'
		| 'Brackets Curly'
		| 'Buildings'
		| 'Calendar Blank'
		| 'Canada'
		| 'Caret Double Left Slim'
		| 'Caret Double Right Slim'
		| 'Caret Left'
		| 'Caret Left Slim'
		| 'Caret Right'
		| 'Caret Right Slim'
		| 'Chalkboard Teacher'
		| 'Chat Circle'
		| 'Check'
		| 'Check Circle'
		| 'Check Square Offset'
		| 'Chevron Down'
		| 'Close'
		| 'Cpu'
		| 'Currency'
		| 'Current Coverage Map Icon'
		| 'Cursor'
		| 'Cursor Two'
		| 'Download'
		| 'Facebook'
		| 'Funnel'
		| 'Future Coverage Map Icon'
		| 'Gift'
		| 'Globe'
		| 'Google'
		| 'Handshake'
		| 'Heartbeat'
		| 'International'
		| 'Play Circle'
		| 'Play Circle Outline'
		| 'Play Arrow'
		| 'Pause'
		| 'Pause Circle'
		| 'Leaf'
		| 'Lotus'
		| 'Magnifying Glass'
		| 'Maple Leaf'
		| 'Menu'
		| 'Menu Alternate'
		| 'Mexico'
		| 'Microphone'
		| 'Military'
		| 'New Window'
		| 'Newspaper'
		| 'Note'
		| 'Pencil'
		| 'Question'
		| 'Shield'
		| 'Shield Check'
		| 'Shield Checkered'
		| 'Shield Chevron'
		| 'Stack'
		| 'Success'
		| 'tbk Logo'
		| 'Thumbs Up'
		| 'Tree Structure'
		| 'Upload'
		| 'USA'
		| 'User Focus'
		| 'User Four'
		| 'Wave Sine'
		| 'Wifi High';
}

export interface IIconSampleItem {
	iconName?: string;
}

export interface IIconSamplesProps extends IBaseElementProps {}

const IconSamples: React.FC<IIconSamplesProps> = ({
	className,
	classNames = [],
}) => {
	const calianIconSelectValues = [
		'Activity',
		'Alert',
		'Article',
		'Arrow Right',
		'Barbell',
		'Bell',
		'Brand Linkedin',
		'Brackets Curly',
		'Buildings',
		'Calendar Blank',
		'Canada',
		'Caret Double Left Slim',
		'Caret Double Right Slim',
		'Caret Left',
		'Caret Left Slim',
		'Caret Right',
		'Caret Right Slim',
		'Chalkboard Teacher',
		'Chat Circle',
		'Check',
		'Check Circle',
		'Check Square Offset',
		'Chevron Down',
		'Close',
		'Cpu',
		'Currency',
		'Current Coverage Map Icon',
		'Cursor',
		'Cursor Two',
		'Download',
		'Facebook',
		'Funnel',
		'Future Coverage Map Icon',
		'Gift',
		'Globe',
		'Google',
		'Handshake',
		'Heartbeat',
		'International',
		'Play Circle',
		'Play Arrow',
		'Pause',
		'Pause Circle',
		'Play Circle Outline',
		'Leaf',
		'Lotus',
		'Magnifying Glass',
		'Maple Leaf',
		'Menu',
		'Menu Alternate',
		'Mexico',
		'Microphone',
		'New Window',
		'Newspaper',
		'Note',
		'Military',
		'Pencil',
		'Question',
		'Shield',
		'Shield Check',
		'Shield Chevered',
		'Shield Chevron',
		'Stack',
		'Success',
		'tbk Logo',
		'Thumbs Up',
		'Tree Structure',
		'Upload',
		'USA',
		'User Focus',
		'User Four',
		'Wave Sine',
		'Waifi High',
	];

	return (
		<div className={className || cn('calian-icon-samples', ...classNames)}>
			<div className="container-narrow my-5">
				<div className="row">
					<div className="col-12">
						<h2 className="text-center">Icons</h2>
						<div className="container-fluid text-center my-5">
							<div className="row my-5">
								{calianIconSelectValues.map(
									(iconName, index) => (
										<p className="lead" key={index}>
											{iconName} (classname: icon-
											{kebabCase(iconName)}):{' '}
											<span
												className={`icon icon-${kebabCase(
													iconName,
												)}`}
											></span>
										</p>
									),
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default IconSamples;
